/**
 * Shared date-window validation for pasted groups — formula AND rule groups
 * carry the same trio (dateRange + custom from/to) with the same contract:
 * absent is fine (rules inherit), 'custom' needs both dates, and a set
 * preset must exist in the catalog.
 * For Media Devoted | Created By Ciro Autiero
 */

import type { LibraryValidationContext, ReviewIssue } from '../review-items';

export interface DateWindow {
  dateRange?: string;
  customFrom?: string;
  customTo?: string;
}

export function checkWindowIssues(
  window: DateWindow,
  ctx: LibraryValidationContext,
  issues: ReviewIssue[],
): void {
  if (!window.dateRange) return;
  if (window.dateRange === 'custom') {
    if (window.customFrom && window.customTo) return;
    issues.push({
      level: 'error',
      message: 'Custom date range needs both from and to dates.',
    });
    return;
  }
  const presets = ctx.dateRangePresets;
  if (presets?.size && !presets.has(window.dateRange)) {
    issues.push({
      level: 'error',
      message: `Unknown date range "${window.dateRange}".`,
    });
  }
}
